module.exports = __webpack_public_path__ + "static/media/shorty.e12cbafe.png";